import { DialogActions, DialogContent, DialogTitle, Popover } from '@mui/material';

import { useTranslation } from 'react-i18next';
import TestrunJiraBugsTable from './TestrunJiraBugsTable';
import UtmsButton from '@shared/components/ui/UtmsButton';

export const TestrunJiraBugsPopover = ({ anchorEl, setAnchorEl, testRunResultId, jiraBugs }) => {
    const { t } = useTranslation();
    const open = Boolean(anchorEl);

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <DialogTitle variant="h4">{`${t('jira_bugs')} - ${`${testRunResultId}`}`}</DialogTitle>
            <DialogContent
                sx={{
                    width: 640,
                }}
            >
                <TestrunJiraBugsTable jiraBugs={jiraBugs} readonly />
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleClosePopover}>{t('close')}</UtmsButton>
            </DialogActions>
        </Popover>
    );
};

export default TestrunJiraBugsPopover;
